export const environment = {
    production: true,
    protect: true,
    MAPS_API_KEY: 'AIzaSyBbsgvrQ348Ls8lLGU8WitdzSBtBbUCao4' 
};
